module.exports = __webpack_public_path__ + "img/phisher.889b85db.svg";